import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import DraftResults from "../draft/DraftResults";
import LeagueSeasonAdmin from "../league/LeagueSeasonAdmin";
import LeagueWaivers from "../league/LeagueWaivers";
import TransactionsPage from "../league/TransactionsPage";
import NflGameStats from "../nfl/NflGameStats";
import NflHome from "../nfl/NflHome";
import PlayerSeasonStats from "../player/PlayerSeasonStats";
import SocketTest from "../socket/SocketTest";
import AdminRoutes from "../admin/AdminRoutes";
import Logout from "../auth/Logout";
import SignupForm from "../auth/SignupForm";
import LiveDraft from "../draft/LiveDraft";
import GameMain from "../game/GameMain";
import RouteWrapperWithNav from "../layout/RouteWrapperWithNav";
import LeagueSeasonHome from "../league/LeagueSeasonHome";
import LeagueHome from "../league/LeagueHome";
import LeagueMessageBoard from "../league/LeagueMessageBoard";
import LeaguePlayers from "../league/LeaguePlayers";
import LeaguePowerRankings from "../league/LeaguePowerRankings";
import LeagueRules from "../league/LeagueRules";
import LeagueStandings from "../league/LeagueStandings";
import LeagueWeekGames from "../league/LeagueWeekGames";
import TeamGamesPage from "../team/TeamGamesPage";
import TeamHome from "../team/TeamHome";
import TeamInfo from "../team/TeamInfo";
import TeamLineupPage from "../team/TeamLineupPage";
import TeamRoster from "../team/TeamRosterPage";
import TeamTrades from "../team/TeamTrades";
import Store from "../test/store";
import UserHome from "../users/UserHome";
import Home from "./Home";
import NotFound from "./NotFound";
import Search from "./Search";
import LoginForm from "../auth/LoginForm";

// todo: break these down into types of routes like LeagueRoutes, TeamsRoutes, etc

export const topLevelKeywords = [
  "leagues",
  "login",
  "logout",
  "not-found",
  "search",
  "sign-up",
  "teams",
  "test",
  "users",
];

const Routes = () => {
  const { href, pathname } = window.location;

  const routes = [
    { path: "/admin", comp: AdminRoutes },
    {
      path: "/leagues/:league",
      comp: LeagueHome,
    },
    {
      path: "/login",
      comp: LoginForm,
    },
    {
      path: "/logout",
      comp: Logout,
    },
    {
      path: "/not-found",
      comp: NotFound,
    },
    {
      path: "/search",
      comp: Search,
    },
    {
      path: "/sign-up",
      comp: SignupForm,
    },
    {
      path: "/socket",
      comp: SocketTest,
    },
    {
      path: "/teams/:team",
      comp: TeamInfo,
    },
    {
      path: "/test",
      comp: Store,
    },
    {
      path: "/users/:username",
      comp: UserHome,
    },
    {
      path: "/:league/:season/admin",
      comp: LeagueSeasonAdmin,
    },
    {
      path: "/:league/:season/draft",
      comp: LiveDraft,
    },
    {
      path: "/:league/:season/draft-results",
      comp: DraftResults,
    },
    {
      path: "/:league/:season/message-board/page/:pageNum?",
      comp: LeagueMessageBoard,
    },
    {
      path: "/:league/:season/message-board",
      comp: LeagueMessageBoard,
    },
    {
      path: "/:league/:season/players",
      comp: PlayerSeasonStats,
    },
    {
      path: "/:league/:season/rules",
      comp: LeagueRules,
    },
    {
      path: "/:league/:season/transactions",
      comp: TransactionsPage,
    },
    {
      path: "/:league/:season/waivers",
      comp: LeagueWaivers,
    },
    {
      path: "/:league/:season/:week/games/:game",
      comp: GameMain,
    },
    {
      path: "/:league/:season/:team/games",
      comp: TeamGamesPage,
    },
    {
      path: "/:league/:season/:team/game/:week",
      comp: GameMain,
    },
    {
      path: "/:league/:season/:team/lineup/:week",
      comp: TeamLineupPage,
    },
    {
      path: "/:league/:season/:team/roster/:week?",
      comp: TeamRoster,
    },
    {
      path: "/:league/:season/:team/trades",
      comp: TeamTrades,
    },
    {
      path: "/:league/:season/:week/all-games",
      comp: LeagueWeekGames,
    },
    {
      path: "/:league/:season/:week/nfl/game/:nflGameSlug",
      comp: NflGameStats,
    },
    {
      path: "/:league/:season/:week/nfl",
      comp: NflHome,
    },
    {
      path: "/:league/:season/:week/power-rankings",
      comp: LeaguePowerRankings,
    },
    {
      path: "/:league/:season/:week/standings",
      comp: LeagueStandings,
    },
    {
      path: "/:league/:season/:week/page/:pageNum?",
      comp: LeagueSeasonHome,
    },
    {
      path: "/:league/:season/:team/:week",
      comp: TeamHome,
    },
    {
      path: "/:league/:season/:week",
      comp: LeagueSeasonHome,
    },

    {
      path: "/",
      comp: Home,
      exact: true,
    },
  ];

  return (
    <Switch>
      {routes.map(({ path, comp, exact }, i) => {
        const Comp = comp;
        return exact ? (
          <Route
            key={i}
            path={path}
            exact
            render={() => (
              <RouteWrapperWithNav>
                <Comp />
              </RouteWrapperWithNav>
            )}
          />
        ) : (
          <Route
            key={i}
            path={path}
            render={() => (
              <RouteWrapperWithNav>
                <Comp />
              </RouteWrapperWithNav>
            )}
          />
        );
      })}
      <Redirect
        to={{
          pathname: "/not-found",
          state: {
            href,
            pathname,
          },
        }}
      />
    </Switch>
  );
};

export default Routes;
